import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Collapse, Nav, Navbar, NavbarToggler, Button } from "reactstrap";
import axios from "axios";
import APICalls from "./APICalls";
import { useMsal } from "@azure/msal-react";
import { UserType } from "./MagniTypes";

function Header2() {
    const navigate = useNavigate();
    const { instance } = useMsal();
    const [user, setUser] = useState<UserType>(new UserType());
    const [displayName, setDisplayName] = useState("");
    const [isOpen, setIsOpen] = useState(true);
    // Refs to prevent infinite updates
    const apiCallsRef = useRef(new APICalls());
    const fetchedRef = useRef(false);
    
    // Only run once on mount
    useEffect(() => {
        // Skip if we already tried to fetch
        if (fetchedRef.current) return;
        fetchedRef.current = true;
        
        // First use data from localStorage if available
        const storedName = localStorage.getItem('accountName');
        const storedUser = localStorage.getItem('user');
        
        if (storedName) {
            setDisplayName(storedName);
        } else if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                if (typeof parsedUser === 'object' && parsedUser.UserName) {
                    setDisplayName(parsedUser.UserName);
                    setUser(parsedUser);
                }
            } catch (e) {
                console.error("Error parsing stored user", e);
            }
        }
        
        // Then try to get from Graph API
        const fetchGraphData = async () => {
            try {
                const userData = await apiCallsRef.current.GetUserFromGraph();
                
                if (userData && userData.displayName) {
                    setDisplayName(userData.displayName);
                    
                    const userInfo = new UserType();
                    userInfo.UserName = userData.displayName;
                    setUser(userInfo);
                }
            } catch (error) {
                console.error("Error fetching Graph data:", error);
            }
        };
        
        fetchGraphData();
    }, []); // Empty dependency array - only run once on mount
    
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const logout = () => {
        delete axios.defaults.headers.common['Authorization'];
        localStorage.removeItem('graphUser');
        localStorage.removeItem('graphToken');
        instance.logout();
        navigate("/login");
    };
    
    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ maxWidth: "100%", width: "100%", marginBottom:'20px' }}>
                <Navbar style={{ backgroundColor: "#efefef", padding: "0.5rem 1rem", borderRadius: "20px", }} expand="md">
                    <Nav className="w-100 d-flex align-items-center justify-content-between">
                        <NavbarToggler style={{ backgroundColor: "#EFEFEF" }} onClick={handleToggle} />
                        <Collapse isOpen={isOpen} navbar className="d-flex w-100 justify-content-between">
                            <img
                                style={{ height: 50, borderColor: "#0d0673", marginLeft: '00px' }}
                                src="/Magni2.png"
                                alt="MagniDev Logo"
                            />

                            <h5 style={{ color: "#000000", marginLeft: '-50px', fontSize: '30px' }}>
                                Condition Reports
                            </h5>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div>
                                    <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#000000' }}>
                                        {displayName}
                                    </span>
                                </div>
                                <Button
                                    color="primary"
                                    style={{ fontSize: '16px', padding: '5px 10px', backgroundColor: '#efefef', color: '#000000' }}
                                    onClick={logout}
                                >
                                    Logout
                                </Button>
                            </div>
                        </Collapse>
                    </Nav>
                </Navbar>
            </div>
        </div>
    );
}

export default Header2;